import React, { Component } from 'react';
import logoBaka from "../../images/bakasable-logo.png"
import logoBakaSmall from "../../images/logo-small.png"
import { Link } from 'react-scroll'
import Measure from 'react-measure'

class Header extends Component {

  constructor(props){
    super(props)
    this.state = {
      width: document.documentElement.offsetWidth
    }
  }

  componentDidMount(){
    window.addEventListener("resize", this.resize.bind(this));
  }

  componentWillUnmount(){
    window.removeEventListener("resize", this.resize.bind(this));
  }

  resize(){
    this.setState({
      width:document.documentElement.offsetWidth
    })
  }

  render() {
    const width = this.state.width
    var y = 0
    if(width < 800){
      y = -60
    }

    return (

        <div className="header">
          <img className="logoPetitDej" src={logoBakaSmall}/>
          <ul>
          <li>
            <Link to="concept" spy={true} offset={y} smooth={true} duration={500}>
            Concept
            </Link>
          </li>
          <li>
            <Link to="formules" spy={true} offset={y} smooth={true} duration={500}>
              Formules
            </Link>
          </li>
          <li>
            <Link to="form" spy={true} offset={y} smooth={true} duration={500}>
              Réservez
            </Link>
          </li>
          </ul>
          <a className="linkBaka" target="_blank" href="http://www.bakasable.fr/"><img src={logoBaka}/></a>
        </div>
    )
  }

}

export default Header;



// WEBPACK FOOTER //
// ./src/client/components/partials/header.js